<template>
  <div class="heatmap-wrapper">
    <div class="heatmap-loading-container" v-if="loading">
      <loading :height="30" color="#1ba5a4" :opacity="1" :width="30" :active.sync="loading" :is-full-page="false"
        :can-cancel="false" background-color="#ffffff57" class="loader"></loading>
    </div>
    <div id="department-table-content" @scroll="heatmapScoll" class="table-content" v-if="value.data.length > 0"
      @click="mousePosition">
      <div class="table-container" ref="table-content">
        <!-- Table header -->
        <div class="table-row">
          <div class="consultant-item left-sticky">
            <button class="btn-time-prev" @click="heatmapPrev('scoll')">
              <img src="@/assets/admin-icon/chevron-left.svg" />
            </button>
            <div class="month-header-widget">
              <label>Classes</label>
            </div>
            <div class="year-header-widget"></div>
          </div>
          <div v-for="(item, index) in value.labels" :key="index" class="table-th-item" :class="{
            has_year: (item.month == 'Jan' && index != 0) || index == 0,
          }">
            <div class="year-label" v-if="index == 0">
              {{ item.year | validate }}
            </div>
            <div class="year-label" v-if="item.month == 'Jan' && index != 0">
              {{ item.year | validate }}
            </div>
            <span class="month-label" :class="{
              year_number: (item.month == 'Jan' && index != 0) || index == 0,
              currently: isCurrentMonth(item),
            }">{{ item.month | validate }}</span>
          </div>
          <div class="comments-th right-sticky" :class="{ expanded: comment_expand }">
            <div class="comment-wrapper">
              <button class="btn-next-time" @click="heatmapNext('scoll')">
                <img src="@/assets/admin-icon/chevron-right.svg" />
              </button>
              <label class="comment-title" @click="comment_expand = !comment_expand">Comments</label>
              <button class="btn-resize" @click="comment_expand = !comment_expand">
                <span v-if="comment_expand">Minimize</span>
                <span v-else>Expand</span>
              </button>
            </div>
          </div>
        </div>
        <!-- End of table header -->

        <!-- Start of table body -->
        <div class="table-td-row" v-for="(item, index) in value.data" :key="index">
          <div class="table-td-item-header">
            <div class="consultant left-sticky">
              <button class="btn-toggle-team" @click="expandHeatmapItem(item.team)">
                <img v-if="!item.team.item_expanded" src="@/assets/admin-icon/allow-down.svg" />
                <img v-else src="@/assets/admin-icon/allow-up-white.svg" />
              </button>
              <div class="user-info" :class="{ active: item.team.item_expanded }" @click="expandHeatmapItem(item.team)">
                <label>{{ item.team.profile.name | validate }}</label>
              </div>
            </div>

            <div class="table-td-item" v-for="(piece, i) in item.team.data" :key="i" :class="{
              year_started: yearStarted(piece),
            }" @click="showBoxModal(item.team, 'team', item.team, piece)">
              <div class="color-box" :class="{
                starter: checkHeaderIfStarter(
                  i == 0 ? 'start' : 'middle',
                  piece.color,
                  i == 0 ? piece.color : item.team.data[i - 1].color
                ),
                ender: checkHeaderIfEnder(
                  i == item.team.data.length - 1 ? 'end' : 'middle',
                  piece.color,
                  i == item.team.data.length - 1
                    ? piece.color
                    : item.team.data[i + 1].color
                ),
              }" v-if="piece.color != '#7E7E7E'" :style="{ 'background-color': piece.color }"></div>
            </div>

            <div class="heatmap-comment right-sticky" :class="{
              expanded: comment_expand,
              no_comment: !item.team.comment,
            }" :title="item.team.comment">
              <div class="comment-wrapper">
                <div class="comment-input-wrapper">
                  <input type="text" :class="{ comenting: item.team.modal }" placeholder="Add Comments here..."
                    class="comment-content-editable" v-model="item.team.comment" @blur="updateHeatMapComment()"
                    @keypress.enter="updateHeatMapComment()" @keyup="({ target }) => {
                      form_comment.text = target.value;
                    }
                      " @focus="openModal(item.team, 'team', item.team)" />
                </div>
              </div>
            </div>
          </div>
          <div class="table-td-item-body" :class="{ expanded: item.team.item_expanded }">
            <div class="table-td-body-item" v-for="(member, i) in item.consultants" :key="i">
              <div class="consultant left-sticky">
                <div class="user-info">
                  <img v-if="member.profile.image" :src="$fullUrl('images/profiles/' + member.profile.image)"
                    class="profile" />
                  <img v-else src="@/assets/avatar.png" class="profile" />
                  <label>{{ member.profile.first_name | validate }}
                    {{ member.profile.last_name | validate }}</label>
                </div>
              </div>

              <div class="table-td-item" v-for="(piece, i) in member.data" :key="i" :class="{
                year_started: yearStarted(piece),
              }" @click="showBoxModal(item.team, 'member', member, piece)">
                <div class="color-box" :class="{
                  starter: checkHeaderIfStarter(
                    i == 0 ? 'start' : 'middle',
                    piece.color,
                    i == 0 ? piece.color : member.data[i - 1].color
                  ),
                  ender: checkHeaderIfEnder(
                    i == member.data.length - 1 ? 'end' : 'middle',
                    piece.color,
                    i == member.data.length - 1
                      ? piece.color
                      : member.data[i + 1].color
                  ),
                }" v-if="piece.color != '#7E7E7E'" :style="{ 'background-color': piece.color }"></div>
              </div>

              <div class="heatmap-comment right-sticky" :class="{
                expanded: comment_expand,
                no_comment: !member.comment,
              }" :title="member.comment">
                <div class="comment-wrapper">
                  <div class="comment-input-wrapper">
                    <input type="text" placeholder="Add Comments here..." class="comment-content-editable"
                      :class="{ comenting: member.modal }" @blur="updateHeatMapComment()" v-model="member.comment"
                      @keypress.enter="updateHeatMapComment()" @keyup="({ target }) => {
                        form_comment.text = target.value;
                      }
                        " @focus="openModal(item.team, 'member', member)" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End of table body  -->
      </div>
    </div>

    <div class="empty-heatmap" v-else>
      <img class="icon" src="@/assets/admin-icon/no_heatmap.svg" />
      <h1>Your dashboard is empty</h1>
      <p>You need to add students to start using the heatmap</p>
      <img class="heatmap-image" src="@/assets/image/crm-heatmap.svg" />
      <button @click="
        $router.push({
          name: 'organization',
          params: { type: 'teams' },
        })
        " class="btn-add">
        Add Students
      </button>
    </div>

    <!-- Modal -->
    <updateHeatmapModal :style="box_modal_style" v-if="show_box_modal" :formData="form_data"
      @closeUpdateModal="closeModal()" @saved="(color) => {
        selected_cell.color = color;
        closeModal();
      }
        "></updateHeatmapModal>
  </div>
</template>
<script>
import { eventBus } from "@/main";
import updateHeatmapModal from "@/views/Dashboard/components/update_heatmap_modal.vue";
export default {
  name: "member",
  components: {
    updateHeatmapModal,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  data() {
    return {
      show_box_modal: false,
      comment_expand: true,
      selected_item: {},
      form_comment: {
        id: null,
        text: "",
        type: "",
        crm_department_id: null,
        crm_team_id: null,
      },
      selected_cell: {},
      box_modal_style: {
        top: "0px",
        left: "0px",
      },
      form_data: null,
    };
  },
  mounted() {
    let vm = this;
  },
  methods: {
    yearStarted(piece) {
      return piece.month == "Jan";
    },
    isCurrentMonth(item) {
      let vm = this;
      return (
        item.month == vm.moment().format("MMM") &&
        item.year == vm.moment().format("YYYY")
      );
    },
    closeModal() {
      let vm = this;
      vm.show_box_modal = false;
    },
    showBoxModal(data_item, type, item, cell) {
      let vm = this;
      vm.selected_cell = cell;
      vm.form_data = {
        id: item.id,
        type: type,
        crm_team_id: type == "team" ? data_item.profile.id : null,
        crm_department_id: type == "department" ? data_item.profile.id : null,
        color: "",
        month: cell.month,
        year: cell.year,
      };
      //vm.show_box_modal = true;
    },
    hideAllDeatilsModal() {
      let vm = this;
      if (vm.heatmap_view_type == "member") {
        vm.value.data.forEach((val) => {
          val.team.modal = false;
          val.consultants.forEach((item) => {
            item.modal = false;
          });
        });
      } else if (vm.heatmap_view_type == "team") {
        vm.value.data.forEach((val) => {
          val.department.modal = false;
          val.teams.forEach((item) => {
            item.modal = false;
          });
        });
      }
    },
    openModal(data_item, type, item) {
      let vm = this;
      vm.form_comment = {
        id: null,
        text: "",
        type: "",
        crm_department_id: null,
        crm_team_id: null,
      };
      vm.hideAllDeatilsModal();
      vm.form_comment.id = item.id;
      vm.form_comment.type = type;
      if (vm.form_comment.type == "team" || vm.form_comment.type == "member") {
        vm.form_comment.crm_team_id = data_item.id;
      } else if (vm.form_comment.type == "department") {
        vm.form_comment.crm_department_id = data_item.profile.id;
      }
      vm.form_comment.text = item.comment;
      vm.selected_item = item;
      item.modal = true;
    },
    heatmapPrev(type) {
      let vm = this;
      vm.$emit("prev", type);
    },
    heatmapNext(type) {
      let vm = this;
      vm.$emit("next", type);
    },
    heatmapScoll(nativeEvent) {
      let vm = this;
      if (nativeEvent.target.scrollLeft == 0) {
        if (!vm.loading) {
          vm.$emit("prev");
        }
      }
      if (
        nativeEvent.target.scrollLeft + 300 >
        nativeEvent.target.scrollWidth - nativeEvent.target.offsetWidth
      ) {
        if (!vm.loading) {
          vm.$emit("next");
        }
      }
    },
    mousePosition(e) {
      let vm = this;
      if (e.clientY < 380) {
        vm.box_modal_style = {
          top: e.clientY + "px",
          left: e.clientX + "px",
        };
      } else {
        vm.box_modal_style = {
          top: e.clientY - 240 + "px",
          left: e.clientX + "px",
        };
      }
    },
    checkHeaderIfStarter(location, color, prev_color) {
      if (location != "start") {
        if ("#7E7E7E" == prev_color) {
          return true;
        }
      } else {
        if ("#7E7E7E" != color) {
          return true;
        } else {
          return false;
        }
      }
    },
    checkHeaderIfEnder(location, color, next_color) {
      if (location != "end") {
        if ("#7E7E7E" == next_color) {
          return true;
        }
      } else {
        if ("#7E7E7E" != color) {
          return true;
        } else {
          return false;
        }
      }
    },
    expandHeatmapItem(item) {
      item.item_expanded = !item.item_expanded;
    },
    updateHeatMapComment() {
      let vm = this;
      vm.selected_item.comment = vm.form_comment.text;
      if (vm.form_comment.type == "member") {
        vm.$store
          .dispatch("HEATMAP_UPDATE_USER_COMMENT", vm.form_comment)
          .then((response) => { })
          .catch((error) => {
            console.error({ error });
          });
      } else if (vm.form_comment.type == "team") {
        vm.$store
          .dispatch("HEATMAP_UPDATE_TEAM_COMMENT", vm.form_comment)
          .then((response) => { })
          .catch((error) => {
            console.error({ error });
          });
      } else if (vm.form_comment.type == "department") {
        vm.$store
          .dispatch("HEATMAP_UPDATE_DEPARTMENT_COMMENT", vm.form_comment)
          .then((response) => { })
          .catch((error) => {
            console.error({ error });
          });
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.heatmap-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  .heatmap-loading-container {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 88;
  }

  .table-content {
    max-height: 100%;
    width: 100%;
    overflow-y: auto;
    background-color: #fff;
    padding-left: 0px;
    border-radius: 5px;
    padding: 15px 0px;

    .table-container {
      margin-top: 38px;
      margin-right: 30px;
      display: inline-block;

      &.loading {
        opacity: 0.5;
      }

      .table-row {
        padding: 0px;
        display: inline-flex;
        position: sticky;
        top: 38px;
        background: #fff;
        z-index: 99999;
        margin-bottom: 5px;

        &::after {
          position: absolute;
          content: "";
          width: 100%;
          height: 118px;
          background: #fff;
          top: -80px;
        }

        .consultant-item {
          display: flex;
          align-items: center;
          background: #fff;
          height: 36px;

          .btn-time-prev {
            position: absolute;
            right: -20px;
            z-index: 99;
            top: -36px;

            img {
              width: 11px;
            }
          }

          .month-header-widget {
            position: absolute;
            right: 0px;
            z-index: 999;
            top: -85px;
            bottom: 0px;
            left: 3px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-right: 5px;
            padding-left: 14px;
            color: #959595;

            label {
              font-size: 12px;
              font-weight: 500;
            }
          }

          .year-header-widget {
            position: absolute;
            right: -2px;
            z-index: 99;
            bottom: 34px;
            left: 0px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            height: 40px;
            background: #fff;
          }
        }

        .table-th-item {
          background: #fff;
          width: 100px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          z-index: 99;

          &.divider {
            border-right: 1px solid #ddd;
          }

          &.has_year {
            position: sticky;
            z-index: 9;
            left: 210px;
            background: #fff;
          }

          .year-label {
            position: absolute;
            top: -38px;
            left: -1px;
            padding: 0px 16px;
            font-size: 12px;
            font-weight: 500;
            color: #959595;
            background: #fff;
          }

          .month-label {
            text-transform: uppercase;
            font-size: 11px;

            &.currently {
              color: #fff;
              background: #0884af;
              height: 23px;
              width: 51px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 5px;
            }
          }
        }

        .comments-th {
          width: 250px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          transition: 800ms ease-in-out;

          &.expanded {
            width: 350px;
            transition: 800ms ease-in-out;
          }

          .comment-wrapper {
            display: flex;
            justify-content: space-between;
            background: #fff;
            width: 100%;
            margin-left: 15px;
            padding-top: 13px;
            padding-right: 19px;
            padding-left: 10px;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            position: absolute;
            top: -35px;
            left: 0px;
            right: 0px;
            height: 74px;

            .btn-next-time {
              position: absolute;
              left: -22px;
              top: -3px;
              background: #fff;

              img {
                width: 11px;
              }
            }

            label.comment-title {
              margin: 0px;
              cursor: pointer;
              position: relative;
              top: -17px;
              color: #959595;
              font-size: 12px;
              font-weight: 500;
            }

            .btn-resize {
              color: #0884af;
              height: 16px;
              position: relative;
              top: -17px;
            }
          }
        }
      }

      .table-td-row {
        padding: 0px;

        &:nth-child(even) {
          .table-td-item-header {
            background: #f2f2f2;
          }
        }

        .table-td-item-header {
          padding: 0px 0px;
          display: flex;
          height: 35px;

          .consultant {
            width: 20%;
            height: 100%;
            cursor: pointer;
            background: #fff;
            display: flex;
            align-items: center;
            padding-right: 4px;

            .btn-toggle-team {
              position: absolute;
              top: 0px;
              right: 10px;
              bottom: 0px;
              z-index: 9;

              img {
                width: 10px;
              }
            }

            .user-info {
              display: flex;
              align-items: center;
              width: 100%;
              background: #f0f0f0;
              border-radius: 5px;
              padding-left: 13px;
              height: 30px;
              transition: all 0.3s ease-in-out;

              .profile {
                width: 20px;
                height: 20px;
                border-radius: 50%;
                object-fit: cover;
                margin-right: 4px;
              }

              label {
                width: calc(100% - 24px);
                overflow: hidden;
                text-decoration: none;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
              }

              &.active {
                background: #0884af;
                transition: all 0.3s ease-in-out;

                label {
                  color: rgb(255, 255, 255);
                }
              }
            }
          }

          .table-td-item {
            width: 100px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            cursor: pointer;
            border-left: 1px solid #dddddd;

            //border-top: 1px solid #ddd;
            &.year_started {
              border-left: 3px solid #000;
            }

            .color-box {
              position: absolute;
              top: 0px;
              left: -2px;
              right: -2px;
              bottom: 1px;
              z-index: 9;

              &.starter {
                border-top-left-radius: 10px;
                border-bottom-left-radius: 10px;
              }

              &.ender {
                border-top-right-radius: 10px;
                border-bottom-right-radius: 10px;
                right: 2px;
              }
            }
          }

          .heatmap-comment {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            width: 250px;
            transition: 800ms ease-in-out;
            cursor: pointer;
            height: 100%;

            &.expanded {
              width: 350px;
              transition: 800ms ease-in-out;
            }

            .comment-wrapper {
              width: 100%;
              margin-left: 15px;
              position: absolute;
              right: 0px;
              left: 0px;
              top: 0px;
              bottom: 0px;

              .comment-input-wrapper {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                background: #fff;
                padding-bottom: 2px;
                padding-left: 8px;
                padding-right: 5px;

                .comment-content-editable {
                  width: 100%;
                  height: 100%;
                  background: #fff;
                  padding: 0px 8px;
                  border-radius: 5px;
                  border: 1px solid rgb(230, 230, 230);
                }
              }
            }
          }
        }

        .table-td-item-body {
          width: 100%;
          display: flex;
          flex-direction: column;
          position: absolute;
          transform: scaleY(0);
          transform-origin: top;
          transition: transform 0.26s ease;

          .table-td-body-item {
            width: 100%;
            padding: 0px 0px;
            display: flex;
            height: 27px;
            visibility: hidden;
            opacity: 0;

            &:nth-child(even) {
              background: #f2f2f2;
            }

            .consultant {
              width: 20%;
              height: 100%;
              background: #fff;

              .user-info {
                display: flex;
                align-items: center;
                padding-left: 27px;
                position: absolute;
                top: 0px;
                left: 0px;
                right: 0px;
                bottom: 0px;

                .profile {
                  width: 20px;
                  height: 20px;
                  border-radius: 50%;
                  object-fit: cover;
                  margin-right: 4px;
                }

                label {
                  width: calc(100% - 24px);
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  cursor: pointer;
                }
              }
            }

            .table-td-item {
              width: 100px;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;
              cursor: pointer;
              border-left: 1px solid #ddd;

              &.year_started {
                border-left: 3px solid #000;
              }

              .color-box {
                position: absolute;
                top: 0px;
                left: -2px;
                right: -2px;
                bottom: 1px;
                z-index: 9;

                &.starter {
                  border-top-left-radius: 10px;
                  border-bottom-left-radius: 10px;
                }

                &.ender {
                  border-top-right-radius: 10px;
                  border-bottom-right-radius: 10px;
                  right: 2px;
                }
              }
            }

            .heatmap-comment {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              width: 250px;
              transition: 800ms ease-in-out;
              cursor: pointer;
              height: 100%;

              &.expanded {
                width: 350px;
                transition: 800ms ease-in-out;
              }

              .comment-wrapper {
                width: 100%;
                margin-left: 15px;
                position: absolute;
                right: 0px;
                left: 0px;
                top: 0px;
                bottom: 0px;

                .comment-input-wrapper {
                  width: 100%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  background: #fff;
                  padding-bottom: 2px;
                  padding-left: 8px;
                  padding-right: 5px;

                  .comment-content-editable {
                    width: 100%;
                    height: 100%;
                    background: #fff;
                    padding: 0px 8px;
                    border-radius: 5px;
                    border: 1px solid rgb(230, 230, 230);
                  }
                }
              }
            }
          }

          &.expanded {
            display: flex;
            position: relative;
            max-height: 9000px;
            transform: scaleY(1);
            transition: transform 0.26s ease;

            .table-td-body-item {
              visibility: visible;
              opacity: 1;
            }
          }
        }
      }
    }
  }

  .empty-heatmap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    img.icon {
      width: 100px;
      margin-bottom: 20px;
    }

    h1 {
      font-family: "Nunito", sans-serif;
      font-style: normal;

      font-size: 21px;
      text-align: center;
      color: #cccccc;
      margin: 10px 0px;
    }

    p {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      text-align: center;
      color: #676767;
      margin: 0px 0px;
      margin-bottom: 25px;
    }

    .heatmap-image {
      width: 653px;
      margin-bottom: 20px;
    }

    .btn-add {
      width: 315px;
      height: 50px;
      color: #fff;
      background: #0884af;
      border-radius: 5px;
    }
  }
}
</style>

<style lang="scss">
.left-sticky {
  position: -webkit-sticky;
  /* Safari */
  position: sticky;
  left: 0px;
  z-index: 999;
  width: 200px !important;
  padding: 0px 11px;
}

.right-sticky {
  position: -webkit-sticky;
  /* Safari */
  position: sticky;
  right: 14px;
  z-index: 999;
}
</style>



